import Utils from 'common/utils'
import Analytics from 'analytics'
import Constants from 'common/constants'
import DataSource from 'common/dataStore'



const LOG_PREFIX = "[user-id] "
class UserIdManager {
    sendUserIdToAnalytics(userId) {
        if (Utils.isEmptyStr(userId)) {
            userId = this.generateUserId()
        }
        this.storeUserId(userId)
        console.log(LOG_PREFIX, "Using user-id - ", userId)
        Analytics.setUserId(userId)
    }

    sendAffiliateIdToAnalytics(affiliateId) {
        if (null !== affiliateId) {
            Analytics.setAffiliateId(affiliateId)
        }
    }

    generateUserId() {
        console.log(LOG_PREFIX, "Generating new user-id")
        return `custom-${Utils.generateUUID()}`
    }

    fetchStoredUserId() {
        console.log(LOG_PREFIX, "Fetching user-id from the store")

        if (Utils.isNull(DataSource)) {
            return null
        }

        try {
            return DataSource.getItem(Constants.ANALYTICS.USER_ID)
        } catch (e) {
            console.log(LOG_PREFIX, "Error fetching stored user-id - ", e)
        }
        return null
    }

    storeUserId(userId) {
        if (Utils.isEmptyStr(userId) || Utils.isNull(DataSource)) {
            return false
        }

        try {
            DataSource.setItem(Constants.ANALYTICS.USER_ID, userId)
            return true
        } catch (e) {
            console.log(LOG_PREFIX, "Error storing user-id - ", userId)
        }
        return false
    }
}

let instance = new UserIdManager()
export default instance


// WEBPACK FOOTER //
// ./src/manager/userIdManager.js